<!-- header -->
<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'EXTENSIONS'" [breadcrumb]="''" [count]="total"
    icon="fa-tag">
</app-breadcrumb>
<!-- body -->
<div class="content-background">
    <app-extension-grid (refreshExtensionTotal)="setTotal($event)"></app-extension-grid>
</div>